export default {
	props:{
		loginFormTitle:{type:String, default(){ return this.$t('loginForm.formTitle');} },
		registrationFormTitle:{type:String, default(){ return this.$t('registrationForm.formTitle');} },
		fpassFormTitle:{type:String, default(){ return this.$t('fpassForm.formTitle');} },
		submitUrl:{type:String, default:''},
		email:{type:String, default: ''},
		phoneCcOptions:{type:Array, default(){ return [];} },
		reloadPageOnSuccess:{type:Boolean, default: false},
		googleReCaptchaV3SiteKey:{type:String, default: ''},
	},
	data(){
		return {
			formType: 'login',
			formData:{email:''},
			loginFormSuccessMsg: '',
		}
	},
	watch: {
		email:{
			immediate: true,
			handler(val){
				this.$set(this.formData, 'email', val);
			},
		},
	},
	computed:{
		//
	},
	methods: {
		changeFormType(val){
			this.formType = val;
		},
		onFpassFormSuccess(ev){
			this.loginFormSuccessMsg = ev.success_msg;
			this.changeFormType('login');
		},
		onRegistrationFormSuccess(ev){
			this.loginFormSuccessMsg = ev.success_msg;
			this.changeFormType('login');
		},
	},
	template: `
<div :class="['login-registration-fpass-forms','active-'+formType+'-form']">

	<qit-login-form
			:form-title="loginFormTitle"
			:submit-url="submitUrl"
			:success-msg="loginFormSuccessMsg"
			:email.sync="formData.email"
			:reload-page-on-success="reloadPageOnSuccess"
			:google-re-captcha-v3-site-key="googleReCaptchaV3SiteKey"
	>
		<template v-slot:form-bottom>
      <div class="form-bottom">
        <a @click="changeFormType('fpass')">{{$t('fpassForm.linkForgotMyPassword')}}</a>
				|
        <a @click="changeFormType('registration')">{{$t('registrationForm.linkForRegistration')}}</a>
      </div>
		</template>	
	</qit-login-form>

  <qit-fpass-form
			:form-title="fpassFormTitle"
      :submit-url="submitUrl"
      :email.sync="formData.email"
			@success="onFpassFormSuccess"
      :google-re-captcha-v3-site-key="googleReCaptchaV3SiteKey"
  >
		<template v-slot:form-bottom>
      <div class="form-bottom">
        <a @click="changeFormType('login')"><i class="qicon-1">arrow_left</i></a>
      </div>
		</template>
	</qit-fpass-form>
	
	<qit-registration-form
			:form-title="registrationFormTitle"
      :submit-url="submitUrl"
			v-model="formData"
			:phone-cc-options="phoneCcOptions"
      @success="onRegistrationFormSuccess"
      :google-re-captcha-v3-site-key="googleReCaptchaV3SiteKey"
	>
    <template v-slot:form-bottom>
      <div class="form-bottom">
        <a @click="changeFormType('login')"><i class="qicon-1">arrow_left</i></a>
      </div>
    </template>
	</qit-registration-form>
</div>
`,
}